import React from 'react';
import ProgrammePageRenderer from '../components/ProgrammePageRenderer';

const seatToken = {
  hero: { section_key: 'hero', section_type: 'hero', image: '/images/page-banners/senior-programme.webp' },
  intro: {
    section_key: 'intro',
    section_type: 'intro',
    kicker: 'Senior School Programme',
    title: 'Preparing for Real Life',
    image: '/images/our-program/senior-1.webp',
    description:
      'The 21st century has turned into a competitive sprint. In that space, we want our alumni to outshine and deliver the best. The Senior Programme focuses on in-depth learning along with the necessary on-field and integrated projects.\n\nThe teenage years can be confusing and overwhelming \u2014 but these are also the foundational years of a prospective career. Our Senior Programme ensures that young minds are trained to deal with the insecurities and issues we face in our daily lives, guiding them to be independent and understand the responsibility of learning.',
  },
  focus_header: {
    section_key: 'focus_header',
    section_type: 'header',
    kicker: 'What the Programme Delivers',
    title: 'Rigour, Technology & Exposure',
    extra: { bg: 'light' },
  },
  card_1: {
    section_key: 'card_1',
    section_type: 'card',
    icon: 'fa-award',
    title: 'Academic Rigour',
    description:
      'In-depth learning is paired with integrated and on-field projects. Regular assignments give students multiple channels to express their perspectives while faculty help build strong writing and examination skills.',
  },
  card_2: {
    section_key: 'card_2',
    section_type: 'card',
    icon: 'fa-users',
    title: 'Collaborative Teaching',
    description:
      'Our faculty opt for collaborative teaching where students are constantly motivated and feel supported, building independence and a clear understanding of the responsibility that comes with learning.',
  },
  card_3: {
    section_key: 'card_3',
    section_type: 'card',
    icon: 'fa-laptop',
    title: 'Tech-Enabled Classrooms',
    description:
      'Classrooms are tech-equipped with the tools needed to accelerate the learning journey \u2014 podcasts, e-groups and interactive boards give students constant e-learning support and a better grasp of subjects.',
  },
  card_4: {
    section_key: 'card_4',
    section_type: 'card',
    icon: 'fa-palette',
    title: 'Talent & Exposure',
    description:
      'Talents in music, art, theatre, sports and scientific progress are equally rewarded through regular competitions, with the platform and international exposure to help students reach a wider audience.',
  },
  voices_navy: {
    section_key: 'voices_navy',
    section_type: 'navy',
    kicker: 'The Senior Experience',
    title: 'Built to Outshine',
    extra: { footer: 'Projects promote teamwork and creativity and instil leadership skills \u2014 while faculty simultaneously help students build strong writing and examination skills.' },
  },
  navy_card_1: { section_key: 'navy_card_1', section_type: 'navy_card', icon: 'fa-compass', title: 'Readiness for the real world' },
  navy_card_2: { section_key: 'navy_card_2', section_type: 'navy_card', icon: 'fa-hand-fist', title: 'Confidence through teenage years' },
  navy_card_3: { section_key: 'navy_card_3', section_type: 'navy_card', icon: 'fa-graduation-cap', title: 'Independent, responsible learners' },
  navy_card_4: { section_key: 'navy_card_4', section_type: 'navy_card', icon: 'fa-paintbrush', title: 'Creative, optimistic classrooms' },
  outcome: {
    section_key: 'outcome',
    section_type: 'outcome',
    kicker: 'The Senior Journey',
    title: 'Every Talent, Rewarded',
    description:
      'From science to art, students get the platform and confidence to explore their talents \u2014 with regular competitions and international exposure helping them swiftly reach a wider audience.',
  },
  cta: {
    section_key: 'cta',
    section_type: 'cta',
    icon: 'fa-comment-dots',
    title: 'Beyond the Classroom. Ready for the World.',
    description: 'Discover the Senior School Programme of St. Andrews World School, Indirapuram.',
    button_text: 'Explore Our Programmes',
    button_url: '/our-programmes',
    button2_text: 'Enquire for Admission',
    button2_url: '/admission',
  },
};

const DEFAULT_SECTIONS = [
  seatToken.hero,
  seatToken.intro,
  seatToken.focus_header,
  seatToken.card_1,
  seatToken.card_2,
  seatToken.card_3,
  seatToken.card_4,
  seatToken.voices_navy,
  seatToken.navy_card_1,
  seatToken.navy_card_2,
  seatToken.navy_card_3,
  seatToken.navy_card_4,
  seatToken.outcome,
  seatToken.cta,
];

const seo = {
  title: 'Senior School Programme',
  description: 'Preparing for real life — the Senior School Programme (Grades 9–12) at St. Andrews World School, Indirapuram.',
  keywords: 'Senior School Programme, ICSE school Indirapuram, St Andrews World School, Grades 9 to 12',
};

const SeniorSchoolProgrammePage = () => (
  <ProgrammePageRenderer pageKey="senior" defaults={DEFAULT_SECTIONS} seo={seo} />
);

export default SeniorSchoolProgrammePage;